import Vue from "vue";
import App from "./App.vue";
import linkify from "vue-linkify";
import Flickity from 'vue-flickity'

Vue.directive("linkified", linkify);

Vue.config.productionTip = false;
Vue.config.devtools = true
Vue.component('Flickity', Flickity);
require('fslightbox');

window.Chat = new Vue({
    el: "vue-app",
    data: {
        initialConfig: {
            websocket: '',
            domain: '',
            platform: '',
            platformId: '',
            logo: '',
            brandName: '',
            language: 'it',
            menu: [],
            autocomplete: { 'prefixes': [], 'items': [] },
            delay: 'auto',
            user: {},
            start: { 'value': null, 'text': null },
            notificationKey: '',
            welcome: '',
            action: 'Per cominciare clicca il pulsante "inizia" o scrivi "Ciao"',
            button: 'Inizia',
            ttsEnabled: false,
            sttEnabled: false,
            inWidget: true,
            reset: 'false',
            avatarvideo: false,
            didBearer: '',
            didAvatarVoiceId: '',
            didAvatarVoiceType: ''
        }
    },
    beforeMount: function () {
        this.initialConfig = this.$el.attributes.config ? JSON.parse(this.$el.attributes.config.value) : this.initialConfig;

        // define initial status for the webchat based on variables rendered from the blade template
        this.initialConfig.websocket = this.$el.attributes.websocket ? this.$el.attributes.websocket.value : (this.initialConfig.websocket ? this.initialConfig.websocket : 'websocket.crowdm.it');
        this.initialConfig.domain = this.$el.attributes.domain.value ? this.$el.attributes.domain.value : this.initialConfig.domain;
        this.initialConfig.platform = this.$el.attributes.platform.value ? this.$el.attributes.platform.value : this.initialConfig.platform;
        this.initialConfig.platformId = this.$el.attributes.platformId.value ? this.$el.attributes.platformId.value : this.initialConfig.platformId;
        this.initialConfig.logo = this.$el.attributes.logo ? this.$el.attributes.logo.value : (this.initialConfig.logo ? this.initialConfig.logo : null);
        this.initialConfig.brandName = this.$el.attributes.brand ? this.$el.attributes.brand.value : (this.initialConfig.brand ? this.initialConfig.brand : null);
        this.initialConfig.language = this.$el.attributes.language ? this.$el.attributes.language.value : (this.initialConfig.language ? this.initialConfig.language : null);
        this.initialConfig.menu = this.$el.attributes.menu ? JSON.parse(this.$el.attributes.menu.value) : (this.initialConfig.menu ? this.initialConfig.menu : []);
        this.initialConfig.autocomplete = this.$el.attributes.autocomplete ? JSON.parse(this.$el.attributes.autocomplete.value) : this.initialConfig.autocomplete;
        this.initialConfig.autocomplete = this.initialConfig.autocomplete.items && this.initialConfig.autocomplete.prefixes ? this.initialConfig.autocomplete : { 'prefixes': [], 'items': [] };
        this.initialConfig.delay = this.$el.attributes.delay ? this.$el.attributes.delay.value : (this.initialConfig.delay ? this.initialConfig.delay : 'auto');
        this.initialConfig.user = this.$el.attributes.user ? JSON.parse(this.$el.attributes.user.value) : (this.initialConfig.user ? this.initialConfig.user : {});
        this.initialConfig.start = this.$el.attributes.start ? JSON.parse(this.$el.attributes.start.value) : (this.initialConfig.start ? this.initialConfig.start : { 'value': null, 'text': null });
        this.initialConfig.start = this.initialConfig.start.value && this.initialConfig.start.text ? this.initialConfig.start : { 'value': null, 'text': null };
        this.initialConfig.notificationKey = this.$el.attributes.notificationKey ? this.$el.attributes.notificationKey.value : (this.initialConfig.notificationKey ? this.initialConfig.notificationKey : null);
        this.initialConfig.welcome = this.$el.attributes.welcome ? this.$el.attributes.welcome.value : (this.initialConfig.welcome ? this.initialConfig.welcome : null);
        this.initialConfig.action = this.$el.attributes.action ? this.$el.attributes.action.value : (this.initialConfig.action ? this.initialConfig.action : null);
        this.initialConfig.button = this.$el.attributes.button ? this.$el.attributes.button.value : (this.initialConfig.button ? this.initialConfig.button : null);
        this.initialConfig.inWidget = this.$el.attributes.inWidget ? this.$el.attributes.inWidget.value === 'true' : (this.initialConfig.inWidget ? this.initialConfig.inWidget : false);
        this.initialConfig.reset = this.$el.attributes.reset ? this.$el.attributes.reset.value : (this.initialConfig.reset ? this.initialConfig.reset : null);
        
        this.initialConfig.avatarvideo = this.$el.attributes.avatarvideo ? this.$el.attributes.avatarvideo.value === 'true' : (this.initialConfig.avatarvideo ? this.initialConfig.avatarvideo : false);
        this.initialConfig.didBearer = this.$el.attributes.didBearer ? this.$el.attributes.didBearer.value : (this.initialConfig.didBearer ? this.initialConfig.didBearer : null);
        this.initialConfig.didAvatarVoiceId = this.$el.attributes.didAvatarVoiceId ? this.$el.attributes.didAvatarVoiceId.value : (this.initialConfig.didAvatarVoiceId ? this.initialConfig.didAvatarVoiceId : null);
        this.initialConfig.didAvatarVoiceType = this.$el.attributes.didAvatarVoiceType ? this.$el.attributes.didAvatarVoiceType.value : (this.initialConfig.didAvatarVoiceType ? this.initialConfig.didAvatarVoiceType : null);

        this.initialConfig.ttsEnabled = this.$el.attributes.ttsEnabled ? this.$el.attributes.ttsEnabled.value === 'true' : (this.initialConfig.ttsEnabled ? this.initialConfig.ttsEnabled : false);
        this.initialConfig.sttEnabled = this.$el.attributes.sttEnabled ? this.$el.attributes.sttEnabled.value === 'true' : (this.initialConfig.sttEnabled ? this.initialConfig.sttEnabled : false);
    },
    render(h) {
        return h(App, {
            props: {
                initialConfig: this.initialConfig
            }
        });
    }
});